import User from './user';
import Resident from './resident/index';
import Zhaopin from './zhaopin/index';
import Monitor from './monitor/index';
import Company from './company/index';
import Upload from './upload';
import Web3 from './web3';

const mobxState = {
  user: new User(),
  resident: Resident,
  zhaopin: Zhaopin,
  monitor: Monitor,
  company: Company,
  upload: new Upload(),
  web3: Web3
};

export { User, Upload, Monitor, Company, Zhaopin, Resident, Web3 };

export default mobxState;
